export const boatSellers = (boat, source_field = 'boat_customer') => {
  return boat[source_field]
    ? boat[source_field].filter((customer) => {
        return customer.relation_type === 'seller' || customer.relation_type === 'Verkäufer'
      })
    : []
}
